import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { API_GET_LIST_CLIENT_MY_PAGE_FAVORITES, API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_MORE, apiGetListClientMyPageFavorite, apiGetListClientMyPageFavoriteMore, } from '../../../actions/ClientMyPageActions';
import { apiDeleteFavoriteMany } from '../../../actions/FavoriteActions';
import { isUseSlide } from '../../../define/consts/consultant_search';
import { isAdmin } from '../../../helpers/auth';
import { deleteListItem } from '../../../helpers/common';
import { propArrayShape, propBool, propFunc, propShape, } from '../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../helpers/fetch';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import MyFavoriteColumn from './MyFavoriteColumn';
import MyFavoriteDocument from './MyFavoriteDocument';
import MyFavoriteProfessionals from './MyFavoriteProfessionals';
import MyFavorites from './MyFavorites';
import MyFavoriteSlides from './MyFavoriteSlides';
import MySubscribeProfessionalUnits from './MySubscribeProfessionalUnits';
class MyPageFavorite extends Component {
    constructor(props) {
        super(props);
        this.onChangeChecked = (checked, ids) => {
            const { checks } = this.state;
            [...ids].forEach((id) => {
                deleteListItem(checks, id);
                if (checked) {
                    checks.push(id);
                }
            });
            this.setState({
                checks: [...checks],
            });
        };
        this.state = {
            checks: [],
        };
    }
    componentDidMount() {
        const { favorites, loadFavorites } = this.props;
        if (favorites.length === 0) {
            loadFavorites();
        }
    }
    render() {
        const { deleteFavorites, favorites, isHasMoreFavorites, isLoadingFavorites, isLoadingFavoritesMore, loadFavoritesMore, profile, } = this.props;
        const { checks } = this.state;
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main layout_client_mypage_favorite' }, { children: _jsx("div", Object.assign({ className: 'l-container l-contents' }, { children: _jsxs("div", Object.assign({ className: 'l-container-12' }, { children: [isUseSlide(isAdmin(profile)) && _jsx(MyFavoriteSlides, {}), _jsx(MyFavoriteProfessionals, {}), _jsx(MySubscribeProfessionalUnits, {}), _jsx(MyFavorites, { checks: checks, isHasMore: isHasMoreFavorites, isLoading: isLoadingFavorites, isMoreLoading: isLoadingFavoritesMore, list: favorites, loadFavoriteMore: loadFavoritesMore, onChangeChecked: this.onChangeChecked, onClickDelete: deleteFavorites }), _jsx(MyFavoriteColumn, {}), _jsx(MyFavoriteDocument, {})] })) })) })));
    }
}
MyPageFavorite.propTypes = {
    deleteFavorites: propFunc().isRequired,
    // お気に入り
    favorites: propArrayShape(),
    isHasMoreFavorites: propBool().isRequired,
    isLoadingFavorites: propBool().isRequired,
    isLoadingFavoritesMore: propBool().isRequired,
    // 読み込み
    loadFavorites: propFunc().isRequired,
    loadFavoritesMore: propFunc().isRequired,
    profile: propShape(),
};
MyPageFavorite.defaultProps = {
    favorites: [],
    profile: {},
};
const mapStateToProps = ({ clientMySolution, fetch, profile }) => ({
    favorites: clientMySolution.favorites,
    isHasMoreFavorites: clientMySolution.hasMoreFavorites,
    isHasMoreOrders: clientMySolution.hasMoreOrders,
    isLoadingFavorites: isLoadingApis(fetch, API_GET_LIST_CLIENT_MY_PAGE_FAVORITES),
    isLoadingFavoritesMore: isLoadingApis(fetch, API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_MORE),
    profile,
});
const mapDispatchToProps = (dispatch) => ({
    // お気に入り操作
    deleteFavorites: (list) => dispatch(apiDeleteFavoriteMany(list)),
    // お気に入り取得
    loadFavorites: () => dispatch(apiGetListClientMyPageFavorite()),
    loadFavoritesMore: (list) => dispatch(apiGetListClientMyPageFavoriteMore(list)),
});
const enhance = compose(AuthenticationHoc({ isClient: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(MyPageFavorite);
